import { SessionCategories } from "@/features/coaching/components";
import { useSessionStatus } from "@/features/coaching/hooks";
import {
  ADMIN_SESSION_STATUS,
  getSessionStatusLabel,
} from "@/features/coaching/models";
import { Tabs } from "@/shared/ui";
import { DraftSessions } from "./draft-sessions";
import { AdminPastSessions } from "./past-sessions";
import { AdminUpcomingSessions } from "./upcoming-sessions";

export const CoachingLabTabs = () => {
  const {
    status,
    actions: { setPaginatedStatus },
  } = useSessionStatus();

  return (
    <Tabs.Root
      value={status}
      onValueChange={setPaginatedStatus}
      className="flex grow flex-col gap-6 pb-12"
    >
      <Tabs.List className="[&_*]:capitalize">
        <Tabs.Trigger
          key={ADMIN_SESSION_STATUS.UPCOMING}
          value={ADMIN_SESSION_STATUS.UPCOMING}
        >
          {getSessionStatusLabel(ADMIN_SESSION_STATUS.UPCOMING)}
        </Tabs.Trigger>

        <Tabs.Trigger
          key={ADMIN_SESSION_STATUS.DRAFT}
          value={ADMIN_SESSION_STATUS.DRAFT}
        >
          {getSessionStatusLabel(ADMIN_SESSION_STATUS.DRAFT)}
        </Tabs.Trigger>

        <Tabs.Trigger
          key={ADMIN_SESSION_STATUS.PAST}
          value={ADMIN_SESSION_STATUS.PAST}
        >
          {getSessionStatusLabel(ADMIN_SESSION_STATUS.PAST)}
        </Tabs.Trigger>
      </Tabs.List>

      <SessionCategories />

      <Tabs.Content value={ADMIN_SESSION_STATUS.UPCOMING}>
        <AdminUpcomingSessions />
      </Tabs.Content>

      <Tabs.Content value={ADMIN_SESSION_STATUS.DRAFT}>
        <DraftSessions />
      </Tabs.Content>

      <Tabs.Content value={ADMIN_SESSION_STATUS.PAST}>
        <AdminPastSessions />
      </Tabs.Content>
    </Tabs.Root>
  );
};
